// Security Fix Batch 2B — single source of truth for legal text versions.
// Bump these when the corresponding legal document is updated. Frontend pages
// display this label; the backend stores the same string at consent time so we
// can answer "which version did the user accept?" later.

export const LEGAL_VERSIONS = {
  terms: "2026-06-27",
  privacy: "2026-06-27",
  kvkk: "2026-06-27",
  cookies: "2026-06-27",
  marketing: "2026-06-27", // Açık Rıza / Explicit Consent
};
